export const paramlists = [
    {val: 'country' , desc: 'Country' },
    {val: 'state', desc: 'US State'}
];